<template>
  <TheLoader :active="true" v-if="loading"/>
  <div id="theScrollContainer" class="content-container flex-row" v-else>
    <section class="content white">
      <TheLoader :active="updating" style="opacity:0.5"/>
      <TheEmptyList v-if="items.length < 1" :title="'Ingen objekter'" :large="true" :icon="'glyph-medium-object'"/>

      <table v-if="items.length > 0" class="large fixed sortable visible clickable evenodd contracts table-filter">
        <thead>
          <tr>
            <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === queryParams.sort ? sortClass : '']" @click="changeSorting(heading.sortKey)">
              {{heading.name}}
              <span id="sorttable_sortrevind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'desc'">&nbsp;</span>
              <span id="sorttable_sortfwdind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'asc'">&nbsp;</span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in items" v-bind:key="item.Objektid" @click="showObjektItem($event, item)">
            <td>
              <div class="flex-container">
                <span class="thumbnail-container">
                  <span class="thumbnail small placeholder animation">
                    <template v-if="objektLarge(item)">
                      <img class="hi-trigger" :src="objektLarge(item)" :data-hi-src-full="objektLarge(item)" data-hi-size="large" />
                    </template>
                    <template v-else>
                      <span class="placeholder"></span>
                    </template>
                  </span>
                  <a href="javascript:;" class="primary-title">{{item.Objektnr}}</a>
                </span>
              </div>
            </td>

            <td class="show-for-small">
              {{item.Auksjon || '-'}}
            </td>

            <td class="show-for-small has-tooltip" :data-tooltip="item.title + (item.subtitle ? '<br>' + item.subtitle : '')">
              {{item.title | truncate(30)}}
              <span class="opacity-60" v-if="item.subtitle"><br>{{item.subtitle | truncate(30)}}</span>
            </td>

            <td class="show-for-xlarge">
              <span class="opacity-60 has-tooltip" :data-tooltip="item.Katalogtekst2">{{item.Katalogtekst2 | truncate(40)}}</span>
            </td>
            <td class="show-for-small align-right">
              <span class="opacity-60">
                {{item.Salgspris | thousands}}
              </span>
            </td>

            <td class="show-for-medium align-right">
              <span class="opacity-60">
                {{getPaidAmount(item) | thousands}}
              </span>
            </td>

            <td class="show-for-medium align-right">
              <span v-if="item.oppgjorsbilag && item.oppgjorsbilag.utbetaltdato">{{item.oppgjorsbilag.utbetaltdato | avantidate}}</span>
              <span v-else>-</span>
            </td>
            <td class="show-for-medium align-right">
              <span v-if="item.oppgjorsbilag && item.oppgjorsbilag.Forfallsdato">{{item.oppgjorsbilag.Forfallsdato | avantidate}}</span>
              <span v-else>-</span>
            </td>

            <td class="show-for-medium align-right">
              {{item.Lev_dato | avantidate}}
            </td>

            <td class="show-for-medium align-right">
              <span v-if="item.kontrakt.mottaker" class="avatar name left" :class="strToAvatarClass(item.kontrakt.mottaker.initials)">{{item.kontrakt.mottaker.initials}} <span class="name">{{item.kontrakt.mottaker.full_name}}</span></span>
              <span v-else class="avatar name left" :class="strToAvatarClass('-')">- <span class="name">Ingen ansvarlig</span></span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-container"  v-if="pageCount > 1">
        <paginate v-model="currentPage"
          :page-count="pageCount"
          :page-range="11"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import KundeService from '@/services/KundeService'
import moment from 'moment'
import bus from '@/plugins/event-bus'
import Papa from 'papaparse'
import fileDownload from 'js-file-download'

export default {
  name: 'KundeCardShowTabObjektSeller',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      headings: [
        {name: 'Objekt', sortKey: 'Objektnr', class: ''},
        {name: 'Auksjon', sortKey: 'Auksjon', class: 'show-for-small'},
        {name: 'Tittel', sortKey: 'Tittel', class: 'show-for-small'},
        {name: 'Tekst', sortKey: 'Katalogtekst2', class: 'show-for-xlarge'},
        {name: 'Tilslag', sortKey: 'Salgspris', class: 'show-for-small align-right'},
        {name: 'Oppgjørsbelop', sortKey: 'oppgjorsbilag.Totalbelop', class: 'show-for-medium align-right'},
        {name: 'Utbetalt', sortKey: 'oppgjorsbilag.utbetaltdato', class: 'show-for-medium align-right'},
        {name: 'Planlagt utbetalt', sortKey: 'oppgjorsbilag.Forfallsdato', class: 'show-for-medium align-right'},
        {name: 'Utlevert', sortKey: 'Lev_dato', class: 'show-for-medium align-right'},
        {name: 'Ansvarlig', sortKey: '', class: 'show-for-medium align-right'}
      ],
      loadedImages: {}
    }
  },
  created () {
    bus.$off('export-innlev-excel')

    // Note: The fetch of items is done in KundeCard.
    this.currentPage = this.queryParams.page || 1
  },
  updated () {
    setTimeout(function () {
      if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
        if (!window.jQuery('table.fixed').hasClass('sticky')) {
          window.jQuery('table.fixed').addClass('sticky')
          window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
          window.jQuery(window).resize(function () {})
        }
      }

      // Tooltip
      if (window.jQuery('.has-tooltip') && window.jQuery('.has-tooltip').length > 0) {
        let $tooltip = window.jQuery('.tooltip')

        window.jQuery('.has-tooltip').unbind('hover')
        window.jQuery('.has-tooltip').hover(function () {
          let $tooltipData = window.jQuery(this).data('tooltip')

          // let $offsetTop = window.jQuery('#theScrollContainer').offset().top
          // let $offsetHeight = window.jQuery(this).height()
          let $tooltipHeight = $tooltip.height() + 60
          let $scrollTop = window.jQuery(window).scrollTop()
          // let $offsetBottom = window.innerHeight - ($offsetTop - $offsetHeight)

          // console.log('Mounted: ', window.jQuery('#theScrollContainer').top, $offsetBottom, $tooltipHeight)
          $tooltip.html($tooltipData)

          // show tooltip if not already activeted
          if (!$tooltip.hasClass('active')) {
            $tooltip.addClass('active')

            window.jQuery(document).bind('mousemove', function (e) {
              $tooltip.css({
                left: e.pageX,
                top: e.pageY
              })

              if ((e.pageY - $scrollTop) + $tooltipHeight < window.innerHeight) {
              // if ($offsetBottom > $tooltipHeight) {
                $tooltip.css({
                  left: e.pageX - 125,
                  top: e.pageY - $scrollTop + 30
                })
              } else {
                // offset the tooltip if to close to bottom
                $tooltip.css({
                  left: e.pageX - 125,
                  top: e.pageY - $scrollTop - $tooltipHeight
                })
              }
            })
          }
        },
        // hide the tooltip on blur
        function () {
          $tooltip.removeClass('active')

          window.jQuery(document).unbind('mousemove', function (e) {})
        })
      }
    })
  },
  mounted () {
    bus.$on('export-innlev-excel', () => this.exportAsExcel())

    setTimeout(function () {
      if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
        if (!window.jQuery('table.fixed').hasClass('sticky')) {
          window.jQuery('table.fixed').addClass('sticky')
          window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
          window.jQuery(window).resize(function () {})
        }
      }

      // Tooltip
      if (window.jQuery('.has-tooltip') && window.jQuery('.has-tooltip').length > 0) {
        let $tooltip = window.jQuery('.tooltip')

        window.jQuery('.has-tooltip').unbind('hover')
        window.jQuery('.has-tooltip').hover(function () {
          let $tooltipData = window.jQuery(this).data('tooltip')

          // let $offsetTop = window.jQuery('#theScrollContainer').offset().top
          // let $offsetHeight = window.jQuery(this).height()
          let $tooltipHeight = $tooltip.height() + 60
          let $scrollTop = window.jQuery(window).scrollTop()
          // let $offsetBottom = window.innerHeight - ($offsetTop - $offsetHeight)

          // console.log('Mounted: ', window.jQuery('#theScrollContainer').top, $offsetBottom, $tooltipHeight)
          $tooltip.html($tooltipData)

          // show tooltip if not already activeted
          if (!$tooltip.hasClass('active')) {
            $tooltip.addClass('active')

            window.jQuery(document).bind('mousemove', function (e) {
              $tooltip.css({
                left: e.pageX,
                top: e.pageY
              })

              if ((e.pageY - $scrollTop) + $tooltipHeight < window.innerHeight) {
              // if ($offsetBottom > $tooltipHeight) {
                $tooltip.css({
                  left: e.pageX - 125,
                  top: e.pageY - $scrollTop + 30
                })
              } else {
                // offset the tooltip if to close to bottom
                $tooltip.css({
                  left: e.pageX - 125,
                  top: e.pageY - $scrollTop - $tooltipHeight
                })
              }
            })
          }
        },
        // hide the tooltip on blur
        function () {
          $tooltip.removeClass('active')

          window.jQuery(document).unbind('mousemove', function (e) {})
        })
      }
    })
  },
  computed: {
    ...mapGetters('kundeobjektseller', [
      'items',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),
    sortClass: function () {
      return 'sorttable_sorted' + (this.queryParams.direction !== 'asc' ? '_reverse' : '')
    }
  },
  methods: {
    exportAsExcel: function () {
      if (this.pageCount < 2) {
        // Just loop current list
        bus.$emit('onExportExcel', 'exporting')

        this.makeExcel(this.items)

        bus.$emit('onExportExcel', 'submittable')
      } else {
        bus.$emit('onExportExcel', 'exporting')

        const params = this._.cloneDeep(this.queryParams)
        delete params.limit
        params.export = 1

        KundeService.getObjektWhereKundeIsSeller(this.kunde.Kundenr, params)
          .then((response) => {
            this.makeExcel(response.data)
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
          })
          .then(() => {
            bus.$emit('onExportExcel', 'submittable')
          })
      }
    },
    makeExcel: function (items) {
      const fields = []
      const xarray = []

      // Get all headings in correct order...
      this.headings.forEach((item) => {
        // Skip Katalogtekst2
        if (item.sortKey !== 'Katalogtekst2') {
          fields.push(item.name)
        }
      })

      // Push headings into data array
      xarray.push(fields)

      items.forEach((element) => {
        console.log('item: ', element.Objektid)
        const oppg = this.getPaidAmount(element) || 0
        const utbetaltdato = element.oppgjorsbilag && element.oppgjorsbilag.utbetaltdato ? element.oppgjorsbilag.utbetaltdato : ''
        const forfallsdato = element.oppgjorsbilag && element.oppgjorsbilag.Forfallsdato ? element.oppgjorsbilag.Forfallsdato : ''

        const temp = [
          element.Objektnr,
          element.Auksjon,
          element.title + (element.subtitle ? ' / ' + element.subtitle : ''),
          Number(element.Salgspris || 0),
          Number(oppg),
          this.$options.filters.avantidate(utbetaltdato),
          this.$options.filters.avantidate(forfallsdato),
          this.$options.filters.avantidate(element.Lev_dato),
          element.kontraktsansvarlig ? element.kontraktsansvarlig.full_name : '-'
        ]

        // {name: 'Utbetalt', sortKey: 'oppgjorsbilag.utbetaltdato', class: 'show-for-medium align-right'},
        // {name: 'Planlagt utbetalt', sortKey: 'oppgjorsbilag.Forfallsdato', class: 'show-for-medium align-right'},
        // {name: 'Utlevert', sortKey: 'Lev_dato', class: 'show-for-medium align-right'},

        xarray.push(temp)
      })

      // Finally make csv and force download...
      const csv = '\ufeff' + Papa.unparse(xarray, { delimiter: ';' })
      const blob = new Blob([csv], {
        type: 'application/csvcharset=utf-8'
      })

      fileDownload(blob, 'innlevert-' + moment().format('DDMMYYHms') + '.csv')
    },
    getPaid: function (item) {
      if (item.oppgjorsbilag && item.oppgjorsbilag.Forfallsdato) {
        const ldato = moment(moment(item.oppgjorsbilag.Forfallsdato).format('YYYY-MM-DD'))

        return ldato.format('DD.MM.YYYY')
      }

      return false
    },
    getPaidAmount: function (item) {
      if (item.oppgjorsbilag) {
        return item.oppgjorsbilag.belop_total_calculated || 0
      }

      return 0
    },
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
    },
    objektLarge: function (item) {
      if (item.photos && item.photos.large && item.photos.large.length > 0) {
        return item.photos.large[0]
      }

      return null
    },
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = page
        copiedParams.page = vm.currentPage

        vm.$store.dispatch('kundeobjektseller/reload', {
          kundenr: vm.kunde.Kundenr,
          queryParams: copiedParams
        })
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = 1
      copiedParams.page = this.currentPage

      if (copiedParams.sort === sortKey) {
        copiedParams.direction = copiedParams.direction === 'asc' ? 'desc' : 'asc'
      } else {
        copiedParams.direction = 'asc'
      }

      copiedParams.sort = sortKey

      this.$store.dispatch('kundeobjektseller/reload', {
        kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      })
    },

    objektLink: function (item) {
      if (!item.innlevav) {
        return null
      }
      return '/kunde/' + item.kontrakt.Kundenr + '?kontrakt=' + item.Kontraktnr + '&objekt=' + item.Objektid
    },
    showObjektItem: function (event, item) {
      window.jQuery('#hi-container').removeClass('active')
      window.jQuery(document).unbind('mousemove')

      this.loadObjektModal(item.Objektid)
      // window.location.href = '/kunde/' + item.kontrakt.Kundenr + '?kontrakt=' + item.Kontraktnr + '&objekt=' + item.Objektid

      // this.$router.push({
      //   name: 'KundeCard',
      //   params: {kunde_id: item.innlevav.Kundenr},
      //   query: {kontrakt: item.Kontraktnr, objekt: item.Objektid},
      //   hash: '#oppgjor'
      // })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShowTabObjektSeller.vue